module.exports = __webpack_public_path__ + "static/media/policy.5feed330.png";